import React, { useState, useEffect } from "react";
import { MDBContainer } from "mdbreact";

import api from "../../../../services/api";

import "./styles.css";

import Banner from "../../../template/Banner";
import NewsCard from "../../../template/NewsCard";
import Loader from "../../../template/ShareBtns";
import Pagination from "../../../template/Pagination";

export default () => {
  const [data, setData] = useState(null);
  const [actionsData, setActionsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);

  const description = "Numquam aliquam quae vitae saepe! Harum deleniti";

  useEffect(() => {
    (async function fetchActionsData() {
      setLoading(true);

      try {
        const { data } = await api.get(
          `/posts?pagesize=5&category=6&page=${page}`
        );

        if (data.success) {
          setData(data);
          setActionsData(data.posts);
        }
      } catch (error) {
        console.error(error.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [page]);

  return (
    <div>
      <Banner title="DEPOIMENTOS" subtitle={description} />

      <MDBContainer className="content">
        <p className="text-intro">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil ducimus
          tempora magnam necessitatibus porro, cupiditate illo perspiciatis
          commodi placeat doloribus eum rerum inventore. Itaque, recusandae
          tenetur facere nobis culpa minima. Lorem ipsum dolor sit amet
          consectetur adipisicing elit. Nihil ducimus tempora magnam
          necessitatibus porro, cupiditate illo perspiciatis commodi placeat
          doloribus eum rerum inventore. Itaque, recusandae tenetur facere nobis
          culpa minima.
        </p>
      </MDBContainer>
      <MDBContainer>
        <div className="my-5">
          {loading ? (
            <Loader />
          ) : (
            <div className="my-5">
              {actionsData.map((item) => (
                <NewsCard
                  key={item.id}
                  img={item.image_url}
                  date={item.date}
                  author={item.author}
                  title={item.title}
                  subtitle={item.description}
                  path={`/impacto/depoimentos/${item.slug}`}
                />
              ))}

              {data && data.total_page > 1 && (
                <Pagination
                  setPage={setPage}
                  page={page}
                  totalPage={data.total_page}
                />
              )}
            </div>
          )}
        </div>
      </MDBContainer>
    </div>
  );
};
